import React, { useMemo } from 'react';
import { IconLeftOutlined } from '@osui/icons-icloud';
import classNames from 'classnames';
import './Header.less';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const defaultOnBack = () => {
  window.history.back();
};

function Header(props) {
  const {
    hasBack = false,
    className,
    onBack = defaultOnBack,
    backText = '返回',
    title,
    extra,
    summary,
    fixed = false,
    top = 50,
    children,
    style,
    subTitle
  } = props;
  const calcStyle = useMemo(() => ({
    top: fixed ? top : 0,
    position: fixed ? 'fixed' : 'relative',
    ...style
  }), [top, fixed, style]);
  const calcClassName = classNames('icloud-ui-page-layout-header', {
    'icloud-ui-page-layout-header-has-back': hasBack,
    'icloud-ui-page-layout-header-no-back': !hasBack,
    'icloud-ui-page-layout-header-has-back-text': !!backText,
    'icloud-ui-page-layout-header-has-children': !!children
  }, className);

  const renderSubTitle = () => subTitle && /*#__PURE__*/_jsx("span", {
    className: "icloud-ui-page-layout-header-primary-subTitle",
    children: subTitle
  });

  const renderTitle = () => title && /*#__PURE__*/_jsxs("h2", {
    children: [title, renderSubTitle()]
  });

  const renderBack = () => hasBack && /*#__PURE__*/_jsxs("a", {
    onClick: onBack,
    className: "icloud-ui-page-layout-header-back",
    children: [/*#__PURE__*/_jsx(IconLeftOutlined, {}), /*#__PURE__*/_jsx("span", {
      children: "\u8FD4\u56DE"
    })]
  });

  const renderSummary = () => summary && /*#__PURE__*/_jsx("div", {
    className: "icloud-ui-page-layout-header-summary",
    children: summary
  });

  const renderExtra = () => extra && /*#__PURE__*/_jsx("div", {
    className: "icloud-ui-page-layout-header-primary-extra",
    children: extra
  });

  return /*#__PURE__*/_jsxs("div", {
    className: calcClassName,
    style: calcStyle,
    children: [/*#__PURE__*/_jsxs("div", {
      className: "icloud-ui-page-layout-header-primary",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "icloud-ui-page-layout-header-primary-left",
        children: [renderBack(), renderTitle(), renderSummary()]
      }), renderExtra()]
    }), children && /*#__PURE__*/_jsx("div", {
      className: "icloud-ui-page-layout-header-children",
      children: children
    })]
  });
}

Header.displayName = "Header";
export default Header;
//# sourceMappingURL=es/Header.js.map